import { render, staticRenderFns } from "./forms/subject_form.html?vue&type=template&id=4d9e0ace&"
import script from "./EditSubject.vue?vue&type=script&lang=js&"
export * from "./EditSubject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports